import React from "react"
import {
  Typography,
  CircularProgress,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
} from "@mui/material"
import { gql, useSubscription, useMutation } from "@apollo/client"

const GET_TASKS = gql`
  subscription {
    task {
      user {
        name
        email
      }
      id
      organisation_id
      title
      content
      created_at
      check_list
      archived_at
    }
  }
`

const ARCHIVE_CARD = gql`
  mutation MyMutation($id: Int!) {
    update_task_by_pk(pk_columns: { id: $id }, _set: { archived_at: "now()" }) {
      archived_at
    }
  }
`

export default function TaskList() {
  const { data, loading, error } = useSubscription(GET_TASKS)
  const [archiveCard] = useMutation(ARCHIVE_CARD)
  if (loading) return <CircularProgress />
  if (error) return <Typography>{error.message}</Typography>

  return (
    <>
      <Typography variant="h3" component="h2" gutterBottom>
        Tasks
      </Typography>
      <Grid container spacing={3}>
        {data.task
          .filter((t) => t.archived_at === null)
          .map((task) => (
            <Grid item xs={12} key={task.id}>
              <Card>
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {task.user.name}
                  </Typography>
                  <Typography variant="h5" component="div">
                    {task.title}
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    {task.content}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    onClick={() => archiveCard({ variables: { id: task.id } })}
                  >
                    Mark Complete
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
      </Grid>
    </>
  )
}
